export const unarray = <T>(arrOrValue: T): T extends Array<T> ? T[number] : T =>
  Array.isArray(arrOrValue) ? arrOrValue[0] : arrOrValue;
